const WilleModal = {
    backdrop: "static",
    buttons: {},
    content: null,
    id: "modal",
    size: null,
    title: null,
    closeEnabled: true,

    /**
     * @param {string} id
     * @param {string} label
     * @param {string} classs
     * @param {function} callback
     */
    addButton: function(id, label, classs, callback) {
        this.buttons[id] = {};
        this.buttons[id].label = label;
        this.buttons[id].classs = classs;
        this.buttons[id].callback = callback;

        return this;
    },

    build: function() {
        let modalContainer = $("#" + this.id);
        if (modalContainer.length) {
            this.reset();
            return this;
        }

        let size = "";
        if ("large" === this.size) {
            size = " modal-lg";
        }
        if ("small" === this.size) {
            size = " modal-sm";
        }

        let html = $("<div id=\"" + this.id + "\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"></div>");
        let htmlModalDialog = $("<div class=\"modal-dialog" + size + "\" role=\"document\"></div>");
        let htmlModalContent = $("<div class=\"modal-content\"></div>");
        let htmlModalHeader = $("<div class=\"modal-header\"></div>");
        let htmlModalBody = $("<div class=\"modal-body\" id=\"dialogBody\">" + this.content + "</div>");
        let htmlModalFooter = $("<div class=\"modal-footer\" id=\"dialogButtons\"></div>");

        if ("" !== this.title) {
            htmlModalHeader.append("<h5 class=\"modal-title\">" + translate(this.title) + "</h5>");
            if (true === this.closeEnabled) {
                htmlModalHeader.append("<button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\"><span aria-hidden=\"true\">&times;</span></button>");
            }
            htmlModalContent.append(htmlModalHeader);
        }

        htmlModalContent.append(htmlModalBody);

        if (typeof this.buttons != "undefined") {
            $.each(this.buttons, function(i, attribs) {
                const button = $("<button type=\"submit\">" + translate(attribs.label) + "</button>")
                    .attr("class", ("" === attribs.classs) ? "btn" : attribs.classs)
                    .on("click.lemocore.modal", attribs.callback);

                htmlModalFooter.append(button);
            });

            htmlModalContent.append(htmlModalFooter);
        }

        htmlModalDialog.append(htmlModalContent);
        html.append(htmlModalDialog);

        $("body").append(html);

        modalContainer = $('#' + this.id);
        modalContainer.modal({
            backdrop: "static",
            show: true,
            keyboard: this.closeEnabled,
        });

        if (true === this.closeEnabled) {
            const closeSign = modalContainer.find(".modal-header > .close");
            closeSign
                .off("click.lemocore.modal")
                .on("click.lemocore.modal", function(e) {
                e.preventDefault();
                WilleModal.close().then();
            });

            $(document)
                .off("keydown.lemocore.modal")
                .on("keydown.lemocore.modal", function(e) {
                    let code = parseInt(e.keyCode ? e.keyCode : e.which);
                    if (code === 27) {
                        e.preventDefault();
                        WilleModal.close().then();
                    }
                });
        }

        this.reset();

        return this;
    },

    disableClose: function() {
        this.closeEnabled = false;
    },

    enableClose: function() {
        this.closeEnabled = true;
    },

    reset: function() {
        this.buttons = {};
        this.content = null;
        this.id = "modal";
        this.title = null;
        this.closeEnabled = true;
        return this;
    },

    close: function() {
        return new Promise((resolve, reject) => {
            const modal = $(".modal").last();
            if (!modal.length) {
                reject('modal does not exist');
            }

            modal
                .one("hidden.bs.modal", function(e) {
                    e.preventDefault();
                    $(this).remove();

                    const modalContainer = $(document).find(".modal");
                    if (!modalContainer.length) {
                        $(document).off(".lemocore.modal");
                    }

                    const iframe = $("#uploadiframe");
                    if (iframe.length) {
                        iframe.remove();
                    }

                    resolve('modal window closed');
                })
                .modal("hide");
        });
    },

    /**
     * @param {string} content
     */
    setContent: function(content) {
        this.content = content;
        return this;
    },

    /**
     * @param {string} id
     */
    setId: function(id) {
        this.id = id;
        return this;
    },

    /**
     * @param {string} size
     */
    setSize: function(size) {
        if ("large" === size || "small" === size) {
            this.size = size;
        }
        return this;
    },

    /**
     * @param {string} title
     */
    setTitle: function(title) {
        this.title = title;
        return this;
    }
};